import { join } from 'light-component';
import { Input, InputNumber } from 'antd';
import { Box } from '../../../box';
import { Block } from '../../../block';
import { Highlighter } from '../../component';
import { service } from '../service';
import styles from '../style.module.less';
import type { ReactElement } from 'react';
import type { NumberProps } from './types';

export function NumberInputMode(props: NumberProps): ReactElement {
  const useMobileValidator = props.extend?.custom_mobile_validator === true;
  const onMobileInputChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = event.target;
    if (!/^\d{0,11}$/.test(value)) {
      return;
    }
    props.onPropsChange?.({ value });
  };

  return (
    <Box className={styles.inputBox} style={{ marginLeft: service.getIndent(props.path, 0.7) }}>
      <Box className={styles.subject}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
          require={props.validator === 'required'}
        />
      </Box>
      <Box className={join(styles.action, styles.input)}>
        <Block if={useMobileValidator}>
          <Input
            value={props.value}
            inputMode='numeric'
            maxLength={11}
            readOnly={props.readonly === true}
            placeholder={props.textPlaceholder}
            onChange={onMobileInputChange}
          />
        </Block>
        <Block if={!useMobileValidator}>
          <InputNumber
            style={{ width: '100%' }}
            value={props.value}
            type='number'
            readOnly={props.readonly === true}
            placeholder={props.textPlaceholder}
            onChange={value => props.onPropsChange?.({ value })}
          />
        </Block>
      </Box>
    </Box>
  );
}
